import $ from "jquery";
export const cookieManager = {
    cookie: (name, value, opts) => {
        if (typeof value != "undefined") {
            const path = opts.cookieSettings.path || "/";
            let expires;
            let date;
            if (opts.cookieSettings.expires !== 0 &&
                opts.cookieSettings.duration === "seconds") {
                date = new Date();
                date.setTime(date.getTime() + opts.cookieSettings.expires * 1000);
                expires = "; expires=" + date.toUTCString();
            }
            else if (opts.cookieSettings.expires !== 0 &&
                opts.cookieSettings.duration === "years") {
                date = new Date();
                date.setFullYear(date.getFullYear() + opts.cookieSettings.expires);
                expires = "; expires=" + date.toUTCString();
            }
            document.cookie =
                name +
                    "=" +
                    encodeURIComponent(!value ? "" : value) +
                    expires +
                    "; path=" +
                    path;
            return true;
        }
        else {
            let cookie = null;
            let val = null;
            if (document.cookie && document.cookie !== "") {
                const cookies = document.cookie.split(";");
                const clen = cookies.length;
                for (let i = 0; i < clen; ++i) {
                    cookie = $.trim(cookies[i]);
                    if (cookie.substring(0, name.length + 1) === name + "=") {
                        const len = name.length;
                        val = decodeURIComponent(cookie.substring(len + 1));
                        break;
                    }
                }
            }
            return val;
        }
    },
};
